module.exports = __webpack_public_path__ + "img/quemsomos.ca964658.jpg";